import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const AlertsViewer = () => {
    return _jsx(ToastContainer, { containerId: 'alerts' });
};
export default AlertsViewer;
